import { useEffect, useContext } from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import {
    ESelectCustomPrimary,
    ESelectThemePrimary,
} from '../../../commons/statics/controls';
import { IMenu, IMenuItem } from '../../interfaces/items';
import { QuestionsContext } from '../../context/Questions';
import './menu.scss';

function Menu({ items }: IMenu) {
    const { selectedMenu, changeSelectedMenu } = useContext(QuestionsContext);
    const selectStyles = ESelectCustomPrimary;
    const selectTheme = ESelectThemePrimary;

    const changeItem = (item: IMenuItem) => {
        changeSelectedMenu(item);
    };

    useEffect(() => {
        changeSelectedMenu(items[0]);
    }, [items]);

    return (
        <>
            {items.length > 0 && (
                <>
                    <nav className="Menu">
                        <ul>
                            {items.map((item) => (
                                <li
                                    onClick={() => changeItem(item)}
                                    key={item.value}
                                    className={classNames({
                                        Active:
                                            item?.value?.toString() ===
                                            selectedMenu?.value?.toString(),
                                    })}
                                >
                                    {item.label}
                                </li>
                            ))}
                        </ul>
                    </nav>
                    <div className="MenuMobile">
                        <p className="MenuMobileText">
                            1 de {items.length} bloques
                        </p>
                        <Select
                            id="menu"
                            name="menu"
                            value={selectedMenu}
                            styles={selectStyles}
                            theme={selectTheme}
                            onChange={(item: any) => changeItem(item)}
                            placeholder="Selecciona una opción"
                            options={items}
                        />
                    </div>
                </>
            )}
        </>
    );
}

export default Menu;
